var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('div',{staticClass:"main-template"},[_c('router-view',{staticClass:"view"})],1),_c('Header',{attrs:{"footer":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }